import React, { useMemo } from "react";

import { SEARCH_KEY, SEARCH_SCOPE_FOLDER_ID_KEY, SEARCH_SCOPE_KEY } from "fond/constants";
import SearchResults from "fond/projects/GlobalSearch/SearchResults";
import { SearchScope } from "fond/topBar/useSearchScope";
import { useQueryParams } from "fond/utils/hooks";

const VALID_SCOPE_TYPES: SearchScope["type"][] = ["workspace", "folder", "recent", "starred", "shared", "market_lens"];

const SearchPage: React.FC = () => {
  const searchQuery = useQueryParams(SEARCH_KEY);
  const scopeType = useQueryParams(SEARCH_SCOPE_KEY);
  const scopeFolderId = useQueryParams(SEARCH_SCOPE_FOLDER_ID_KEY);

  const scope: SearchScope = useMemo(() => {
    const type = scopeType as SearchScope["type"];
    if (!type || !VALID_SCOPE_TYPES.includes(type)) {
      return { type: "workspace", folderId: null, folderName: null };
    }
    return {
      type,
      folderId: scopeFolderId ?? null,
      folderName: null, // Resolved by useScopedSearchData via the folderId
    };
  }, [scopeType, scopeFolderId]);

  return <SearchResults searchQuery={searchQuery ?? ""} scope={scope} />;
};

export default SearchPage;
